const MAX_DISTANCE_KEY = 'max-distance';

const DISTANCE_STEP = 5;

const MAX_DISTANCE = 100;

export { MAX_DISTANCE, DISTANCE_STEP, MAX_DISTANCE_KEY };
